import React from 'react';
import styles from './colHeader.module.css';

interface ColHeaderProps {
  label: React.ReactNode;
  icon?: React.ReactNode;
  fontFamily?: string;
  children?: React.ReactNode;
  actionsAlign?: 'left' | 'right';
}

const ColHeader: React.FC<ColHeaderProps> = ({ label, icon, fontFamily, children, actionsAlign = 'left' }) => (
  <div className={styles.colHeader} style={fontFamily ? { fontFamily } : undefined}>
    {icon && <span className={styles.typeIcon}>{icon}</span>}
    <span className={actionsAlign === 'right' ? styles.labelRight : styles.label}>{label}</span>
    {children && <span className={actionsAlign === 'right' ? styles.actionsRight : styles.actions}>{children}</span>}
  </div>
);

export default ColHeader;
